"use strict";

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

module.exports = compressExpansion;

function compressExpansion(e) {
  var m = e.length;
  var Q = e[e.length - 1];
  var bottom = m;

  for (var i = m - 2; i >= 0; --i) {
    var a = Q;
    var b = e[i];
    Q = a + b;
    var bv = Q - a;
    var q = b - bv;

    if (q) {
      e[--bottom] = Q;
      Q = q;
    }
  }

  var top = 0;

  for (var i = bottom; i < m; ++i) {
    var a = e[i];
    var b = Q;
    Q = a + b;
    var bv = Q - a;
    var q = b - bv;

    if (q) {
      e[top++] = q;
    }
  }

  e[top++] = Q;
  e.length = top;
  return e;
}

;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(compressExpansion, "compressExpansion", "/home/yatham/Dev_BHS_Portal/node_modules/robust-compress/compress.js");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();